<template>
  <div class="paginator">
    <div
      class="paginator__button paginator__button--control"
      :class="{ 'paginator__button--disabled': current <= 1 }"
      @click="previous()"
    >
      {{ i18n.paginatorPrevious }}
    </div>
    <div
      v-for="page in range"
      :key="page"
      class="paginator__button paginator__button--page"
      :class="{ 'paginator__button--active': page === current }"
      @click="go(page)"
    >
      {{ page }}
    </div>
    <div
      class="paginator__button paginator__button--control"
      :class="{ 'paginator__button--disabled': current >= total }"
      @click="next()"
    >
      {{ i18n.paginatorNext }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'paginator',
  model: {
    prop: 'current',
    event: 'paginate'
  },
  props: {
    total: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0
      }
    },
    current: {
      type: Number,
      required: true,
      validator(value) {
        return value > 0
      }
    },
    limit: {
      type: Number,
      required: false,
      default: 3
    },
    i18n: {
      type: Object,
      default() {
        return {
          paginatorPrevious: 'Previous',
          paginatorNext: 'Next'
        }
      }
    }
  },
  emits: ['paginate'],
  data() {
    return {
      begin: this.current - 1,
      end: this.limit
    }
  },
  computed: {
    pages() {
      const pages = []

      for (let page = 1; page <= this.total; page += 1) {
        pages.push(page)
      }

      return pages
    },
    range() {
      const range = this.pages.slice(this.begin, this.end)
      const middle = range[Math.floor((range.length - 1) / 2)]

      if (middle === 1) {
        return range
      }

      let adjustedBegin = this.begin
      let adjustedEnd = this.end

      if (this.begin !== 0 && this.current < middle) {
        adjustedBegin -= 1
        adjustedEnd -= 1
      } else if (this.end !== this.total && this.current > middle) {
        adjustedBegin += 1
        adjustedEnd += 1
      }

      return this.pages.slice(adjustedBegin, adjustedEnd)
    }
  },
  methods: {
    previous() {
      if (this.current > 1) {
        this.$emit('paginate', this.current - 1)
      }
    },
    go(page) {
      if (this.current !== page) {
        this.$emit('paginate', page)
      }
    },
    next() {
      if (this.current < this.total) {
        this.$emit('paginate', this.current + 1)
      }
    }
  }
}
</script>
